const TELREGEX =
  /^(0(2|3[1-3]|4[1-4]|5[1-5]|6[1-4]))(\d{3,4})(\d{4})$/;

const MOBILEREGEX =
  /^(01[016789]{1})-?[0-9]{3,4}-?[0-9]{4}$/;

export const isValidPhoneNumber = (v) => v === "" || TELREGEX.test(v) || MOBILEREGEX.test(v);